import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { filterAllowedReportLink } from '../reportLinks'
import { theme } from '@intelie/ui'

interface Props {
    pageName: string
    uid: string
}
interface PropsPill {
    selected: boolean
}

const REPORT_LINKS = filterAllowedReportLink()

export default function BarSettingsReport({ pageName, uid }: Props): JSX.Element {
    return (
        <PillBox style={{ marginLeft: 0 }}>
            {REPORT_LINKS.map(({ name, link }) => {
                return (
                    <Link
                        style={{ textDecoration: 'none', outline: 'none', cursor: 'pointer' }}
                        to={{
                            pathname: `/${link}/${uid}`
                        }}
                    >
                        <Pill selected={pageName === link}>
                            <label>{name}</label>
                        </Pill>
                    </Link>
                )
            })}
        </PillBox>
    )
}

const Pill = styled.div<PropsPill>`
    border-radius: 77px;
    height: 24px;
    padding: 4px 16px;
    display: flex;
    align-items: center;
    background-color: ${({ selected, theme }) => (selected ? theme['gray-700'] : theme['gray-200'])};
    label {
        color: ${({ selected }) => (selected ? theme['gray-100'] : theme['gray-700'])};
        font-size: 14px;
        font-family: ${({ theme }) => theme['font-semibold']};
        font-style: normal;
        font-weight: 600;
        line-height: 16px; /* 114.286% */
    }
    border: 0.75px solid ${({ selected, theme }) => (selected ? theme['gray-700'] : theme['gray-200'])};
    transition: all 0.2s;
    ${({ selected, theme }) => {
        if (!selected) {
            return `
                &:hover {
                    border: 0.75px solid ${theme['gray-500']};
                    background-color: ${theme['gray-200']};
                    label {
                        color: ${theme['gray-800']};
                    }
                }
            `
        }
    }}
    * {
        cursor: pointer !important;
    }
`

const PillBox = styled.div`
    display: flex;
    margin-top: 24px;
    margin-bottom: 24px;
    gap: 12px;
`
